import axios from "axios";

export const directionsApi = axios.create({
  baseURL: 'https://api.mapbox.com/directions/v5/mapbox/driving',
  params:{
    alternatives: false,
    geometries: 'geojson',
    overview: 'simplified',
    steps: false,
    access_token: 'pk.eyJ1IjoiZ2Fib2dhYml0byIsImEiOiJja25ybGducnYwampjMzFvMzJtM3BhZ3lsIn0._JfEmngPETXvFd8KvgOdxg'
  }
})

export default directionsApi;